import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import linkState from 'linkstate';

import { auth, GoogleAuthProvider, storage, firestore } from '../../firebase';
import { UploadTaskSnapshot } from 'firebase/storage';

const style = require('./style.less');

export default class Pi extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            authuser: null,
            progress: null
        };
    }

    componentDidMount() {
        auth().onAuthStateChanged(authuser => {
            authuser
                ? this.setState({ authuser })
                : this.setState({ authuser: null });
        });
    }

    componentWillUnmount() {
    }

    piMenu() {
        return (
            <div class={style.pi}>
                <a onClick={() => auth().signInWithRedirect(GoogleAuthProvider)}>&pi;</a>
            </div>
        );
    }

    fileChange = (file) => {
        if (!file) return;

        this.setState({progress:'Creating upload record...'});

        firestore.collection('potw').doc(file.name).set({
            description: this.state.description,
            time: new Date(),
            valid: false
        }).then(() => {
            let img = storage.ref().child(`potw-staging/${file.name}`);
            let task = img.put(file);
            task.on('state_changed', (snapshot: UploadTaskSnapshot) => {
                let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                this.setState({progress:`Upload is ${progress}% done`});
                switch (snapshot.state) {
                    case 'paused':
                        this.setState({progress: 'Upload is paused'});
                        break;
                    case 'running':
                        this.setState({progress:'Upload is running'});
                        break;
                }
            }, (error) => {
                console.log(error);
                this.setState({progress:'Upload failed during progress.'});
            }, () => {
                this.setState({progress:'File upload finished.'});
            });

            return task;
        }).then(console.log)
        .catch((error) =>{
            this.setState({ progress: 'Upload of file failed.' });
            console.error(error);
        });
    }

    handleChange(e:Event) {
        console.log(e);
        let input = e.target as HTMLInputElement;
        let files = input.files;
        this.fileChange(files[0])
    }

    authedMenu({},{authuser, progress, description}) {
        return (
            <div class={style.pi}>
                <div>{this.state.progress}</div>
                { authuser.uid == 'NpgISgDAXcYaMvIjG6GfNwWXdc52' ? (
                <div class={style.upload}>
                    <div>
                        <label>Image Description
                        <input type="text" value={ description } onInput={linkState(this, 'description')}/>
                        </label>
                    </div>
                    <div>
                        <label class="file-upload">
                            <i class="fa fa-cloud-upload"></i> Upload POTW
                            <input onChange={this.handleChange} type="file" />
                        </label>
                    </div>
                </div>
                ) : '' }
                <a onClick={() => auth().signOut()}>{ authuser.displayName }</a>
            </div>
        );
    }

    render(props,state) {
        return state.authuser != null ? this.authedMenu(props,state) : this.piMenu();
    }
}



// WEBPACK FOOTER //
// ./components/pi/index.tsx